import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { AuthServiceProvider } from '../../providers/auth-service/auth-service';
import { AllUsersPage } from '../all-users/all-users';
import { Observable } from 'rxjs';
import { UserDetailsPage } from '../user-details/user-details';
import { DailyActivityPage } from '../daily-activity/daily-activity';
import { HomePage } from '../home/home';
import { ListBillingPage } from '../list-billing/list-billing';
import { ActivitesPage } from '../activites/activites';

/**
 * More Page where the user can
 * Check profile 
 * Contact for technical support
 * 
 */

@IonicPage()
@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
})
export class SettingsPage {
  isAdmin: Observable<any>;
  currentUserInfoObs: Observable<any>;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public $auth: AuthServiceProvider,) {
    this.isAdmin = this.$auth.isAdmin();
    this.$auth.authStateObs().subscribe(state => {
      if (state) {
        this.currentUserInfoObs = this.$auth.getCurrentUserObs();
      }
    });

  }

  ionViewDidLoad() {

  }

  logOutClick() {
    // this.$auth.signOut();
    this.alertCtrl.create({
      title: 'LogOut',
      message: 'Do you want to log out Now',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          // handler: (blah) => {
          //   console.log('Confirm Cancel: blah');
          // }
        }, {
          text: 'Yes',
          handler: () => {
            this.$auth.signOut();
          }
        }
      ]
    }).present();
  }


  /**
   * on click manage users
   */
  manageUsers() {
    this.navCtrl.push(AllUsersPage);
  }

  /**
   * view profile
   */
  myProfile() {
    this.navCtrl.push(UserDetailsPage, { userKey: this.$auth.getCurrentUserKey() })
  }

  /**
   * Input and preview daily activities
   */
  dailyLogs() {
    this.navCtrl.push(DailyActivityPage, { userKey: this.$auth.getCurrentUserKey() })
  }

  /**
   * go to the obd work flow page
   */
  obdWizard() {
    this.navCtrl.push(HomePage);
  }

  /**
   * open current user billing
   */
  myBills() {
    this.navCtrl.push(ListBillingPage);
  }

  /**
   * open activities
   */
  activities() {
    this.navCtrl.push(ActivitesPage);
  }
}




// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts